import React, { Component } from 'react';
import { Icon, Button, Modal, Grid, Message, Image, Segment } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';

import nowWorkspaceImage from '../../images/grafix-banner/noWorkspace.svg';
import { singleLineText } from '../common/RegexValidation';

class NoWorkspace extends Component {

    handleOpen = () => {
        dispatch.app.addOrgModalOpen(true);
    }

    handleClose = () => {
        dispatch.app.addOrgModalOpen(false);
    }

    onSubmit = (formData) => {
        dispatch.app.addNewWorkspace({
            workspaceName: formData.name.trim(),
            user: this.props.user
        });
    }

    render() {
        const orgCreationError = this.props.orgCreationError;
        const inlineStyle = {
            modal: {
                marginTop: '0px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const errorLabel = <div className="customErrorLabel" />;

        return (
            <Segment style={{ padding: '0em' }} vertical>
                <Grid celled='internally' stackable>
                    <Grid.Row textAlign='center'>
                        <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                            <Image src={nowWorkspaceImage} size='large' centered={true} />
                            <p style={{ fontSize: '1.33em' }}>Sorry, You do not have any associated workspace.</p>
                            <div>
                                <Button className="button-submit" id="registerBtn" onClick={this.handleOpen} >CREATE NEW WORKSPACE</Button>
                            </div>
                            <Modal
                                size='tiny'
                                open={this.props.isAddOrgModalOpen}
                                style={inlineStyle.modal}
                                closeOnEscape={false}
                                closeOnDimmerClick={false}
                            >
                                <Modal.Header style={{ color: '#3fa9f5' }}>New Workspace
                                        <Icon style={{ float: 'right' }} size='small' name='cancel' onClick={this.handleClose} />
                                </Modal.Header>
                                <Modal.Content>
                                    <Form noValidate
                                        id='newworkspaceForm'
                                        onValidSubmit={this.onSubmit}
                                    >
                                        <Grid>
                                            {
                                                orgCreationError !== "" ?
                                                    <Grid.Row>
                                                        <Grid.Column>
                                                            <Message negative>
                                                                <p>{orgCreationError}</p>
                                                            </Message>
                                                        </Grid.Column>
                                                    </Grid.Row> : null
                                            }
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <Form.Input
                                                        required
                                                        name="name"
                                                        id="name"
                                                        label="Workspace name"
                                                        placeholder="Workspace name"
                                                        validations={{ noSpaces: true, matchRegexp: singleLineText }}
                                                        errorLabel={errorLabel}
                                                        validationErrors={{
                                                            noSpaces: 'Workspace name should not be empty',
                                                            matchRegexp: 'Max limit is 128.',
                                                            isDefaultRequiredValue: 'Workspace Name is required',
                                                        }}
                                                        instantValidation
                                                    />
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <Button floated='right' className="button-submit" type="submit" id="submit">Add</Button>
                                                    <Button floated='right' onClick={this.handleClose} >Cancel</Button>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        <div>
                                        </div>
                                    </Form>
                                </Modal.Content>
                            </Modal>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        );
    }

}

function mapStateToProps(state) {
    return {
        isAddOrgModalOpen: state.app.isAddOrgModalOpen,
        user: state.app.user,
        selectedOrganisation: state.app.selectedOrganisation,
        orgCreationError: state.app.orgCreationError,
    };
}

const connectedOrgSelector = connect(mapStateToProps)(NoWorkspace);
export { connectedOrgSelector as NoWorkspace }; 